/**
 * Product mockup: the six spiral volumes fanned out over the "52".
 * Used in the hero and the pricing card.
 */
export const heroImage =
  'https://cdn.magicpatterns.com/uploads/7d9dsWzYibfuZJ58WLtoyz/hero-art.png'
